import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Tooltip from "@material-ui/core/Tooltip";
import withCustomStyles from "./GStepper.style";
import GButton from "./GButton";

const PlusIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.8"
    strokeLinecap="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const MinusIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.8"
    strokeLinecap="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5 12h14" />
  </svg>
);

const stop = handler => event => {
  // the whole product card is a link; the stepper must not navigate
  event.preventDefault();
  event.stopPropagation();
  handler(event);
};

// Add-to-cart control.
// qty 0: round "+" (tile / inline) or a black "Add to cart" pill (lg).
// qty ≥ 1: one black pill "− qty +". "+" disables at the purchase limit.
const GStepper = ({
  classes,
  className,
  qty,
  onAdd,
  onRemove,
  addDisabled,
  limitLabel,
  name,
  size,
  addLabel
}) => {
  const addControl = (
    <button
      type="button"
      onClick={stop(addDisabled ? () => {} : onAdd)}
      aria-label={`Add one ${name}`}
      aria-disabled={addDisabled || undefined}
      className={classnames(classes.stepBtn, {
        [classes.disabled]: addDisabled
      })}
    >
      <PlusIcon />
    </button>
  );

  if (!qty) {
    if (size === "lg") {
      return (
        <GButton
          size="lg"
          fullWidth
          onClick={stop(onAdd)}
          className={className}
        >
          {addLabel}
        </GButton>
      );
    }
    return (
      <button
        type="button"
        onClick={stop(onAdd)}
        aria-label={`Add ${name} to cart`}
        className={classnames(classes.addRound, classes[size], className)}
      >
        <PlusIcon />
      </button>
    );
  }

  return (
    <div
      className={classnames(classes.pill, classes[size], className)}
      role="group"
      aria-label={`${name} quantity`}
    >
      <button
        type="button"
        onClick={stop(onRemove)}
        aria-label={qty === 1 ? `Remove ${name}` : `Remove one ${name}`}
        className={classes.stepBtn}
      >
        <MinusIcon />
      </button>
      <span className={classes.qty} aria-live="polite">
        {qty}
      </span>
      {addDisabled ? (
        <Tooltip enterTouchDelay={0} title={limitLabel}>
          {addControl}
        </Tooltip>
      ) : (
        addControl
      )}
    </div>
  );
};

GStepper.propTypes = {
  qty: PropTypes.number,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  addDisabled: PropTypes.bool,
  limitLabel: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.oneOf(["tile", "inline", "lg"]),
  addLabel: PropTypes.node
};

GStepper.defaultProps = {
  qty: 0,
  addDisabled: false,
  limitLabel: "Purchase limit reached",
  name: "item",
  size: "tile",
  addLabel: "Add to cart"
};

export default withCustomStyles(GStepper);
